'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const SecurePaymentIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.8228 14.3878V16.0499L10.5208 20.9917L3.21891 16.0499L3.18567 4.51526L10.5208 2.85321L17.7895 4.51526L17.8228 7.24102M10.6206 9.63437H20.5929M20.8145 12.9585V7.97232C20.8145 7.36291 20.3159 6.86429 19.7064 6.86429H11.6289C11.0195 6.86429 10.5208 7.36291 10.5208 7.97232V12.9585C10.5208 13.5679 11.0195 14.0665 11.6289 14.0665H19.7064C20.3159 14.0665 20.8145 13.5679 20.8145 12.9585Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpSecurePaymentIcon = forwardRef(SecurePaymentIcon);

export { VpSecurePaymentIcon as default };
